<ng-container [ngSwitch]="buttonType">
  <ng-container *ngSwitchCase="'raised'">
    <button [ngClass]="buttonClass" mat-raised-button type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon> {{buttonText}}
    </button>
  </ng-container>
  <ng-container *ngSwitchCase="'stroked'">
    <button [ngClass]="buttonClass" mat-stroked-button type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon> {{buttonText}}
    </button>
  </ng-container>
  <ng-container *ngSwitchCase="'flat'">
    <button [ngClass]="buttonClass" mat-flat-button type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon> {{buttonText}}
    </button>
  </ng-container>
  <ng-container *ngSwitchCase="'icon'">
    <button [ngClass]="buttonClass" mat-icon-button type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon>
    </button>
  </ng-container>
  <ng-container *ngSwitchCase="'fab'">
    <button [ngClass]="buttonClass" mat-fab type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon> {{buttonText}}
    </button>
  </ng-container>
  <ng-container *ngSwitchCase="'mini-fab'">
    <button [ngClass]="buttonClass" mat-mini-fab type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon> {{buttonText}}
    </button>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <button [ngClass]="buttonClass" mat-button type="button" [color]="buttonColor"
            [matMenuTriggerFor]="menu">
      <mat-icon *ngIf="buttonIcon">{{buttonIcon}}</mat-icon> {{buttonText}}
    </button>
  </ng-container>
</ng-container>

<mat-menu #menu="matMenu" class="mtx-grid-column-menu">
  <div class="mtx-grid-column-menu-content"
       (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
    <div class="mtx-grid-column-menu-header" *ngIf="showHeader">
      <ng-template [ngIf]="headerTemplate" [ngIfElse]="defaultHeaderTpl">
        <ng-template [ngTemplateOutlet]="headerTemplate"></ng-template>
      </ng-template>
      <ng-template #defaultHeaderTpl>{{headerText}}</ng-template>
    </div>

    <div class="mtx-grid-column-menu-body">
      <div class="mtx-grid-column-menu-list" *ngIf="sortable"
           cdkDropList (cdkDropListDropped)="_handleDroped($event)">
        <div class="mtx-grid-column-menu-item" *ngFor="let col of columns"
             cdkDrag [cdkDragDisabled]="selectableChecked === 'show'? !col.show : col.hide">
          <svg class="mtx-grid-icon mtx-grid-column-drag-handle-icon" viewBox="0 0 24 24"
               width="24px" height="24px" fill="currentColor" focusable="false">
            <path
                  d="M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z">
            </path>
          </svg>
          <ng-template [ngTemplateOutlet]="checkboxList"
                       [ngTemplateOutletContext]="{ $implicit: col }">
          </ng-template>
        </div>
      </div>

      <div class="mtx-grid-column-menu-list" *ngIf="!sortable">
        <div class="mtx-grid-column-menu-item" *ngFor="let col of columns">
          <ng-template [ngTemplateOutlet]="checkboxList"
                       [ngTemplateOutletContext]="{ $implicit: col }">
          </ng-template>
        </div>
      </div>
    </div>

    <div class="mtx-grid-column-menu-footer" *ngIf="showFooter">
      <ng-template [ngIf]="footerTemplate" [ngIfElse]="defaultFooterTpl">
        <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
      </ng-template>
      <ng-template #defaultFooterTpl>{{footerText}}</ng-template>
    </div>
  </div>
</mat-menu>

<ng-template #checkboxList let-col>
  <ng-container *ngIf="pinnable">
    <button class="mtx-grid-column-pin-button" mat-icon-button type="button"
            [matMenuTriggerFor]="pinList">
      <svg class="mtx-grid-icon mtx-grid-column-pin-icon" *ngIf="col.pinned"
           viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor" focusable="false">
        <path d="M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z" />
      </svg>
      <svg class="mtx-grid-icon mtx-grid-column-pin-off-icon" *ngIf="!col.pinned"
           viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor" focusable="false">
        <path
              d="M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z" />
      </svg>
    </button>
    <mat-menu #pinList="matMenu" class="mtx-grid-column-pin-list">
      <button class="mtx-grid-column-pin-option" type="button"
              *ngFor="let item of pinOptions" mat-menu-item
              (click)="_handlePinSelect(col, item.value)">
        <span class="mtx-grid-column-pin-option-placeholder">
          <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
          <svg class="mtx-grid-icon mtx-grid-column-pin-check-icon" *ngIf="col.pinned==item.value"
               viewBox="0 0 24 24" width="24px" height="24px" fill="currentColor" focusable="false">
            <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
          </svg>
        </span>
        <span class="mtx-grid-column-pin-option-text">{{item.label | toObservable | async}}</span>
      </button>
    </mat-menu>
  </ng-container>

  <mat-checkbox class="mtx-grid-column-menu-item-label" *ngIf="selectable"
                [(ngModel)]="col[selectableChecked]" [disabled]="col.disabled"
                (change)="_handleChecked($event)">
    {{col.header | toObservable | async}}
  </mat-checkbox>
  <span class="mtx-grid-column-menu-item-label" *ngIf="!selectable">
    {{col.header | toObservable | async}}
  </span>
</ng-template>
